import moment from 'moment';
import { IConfigField } from '../../../../../components/auto-table/model';
import { getLocalTime } from '../../../../../lib';
import getFormatMessage from '../../../../../locales/get-format-message';
import {
  IAPICanOpenInvoiceBillItem,
  IAPIUserInfo,
} from '../../../../../model/api-modules';
import { IBillAsBillOrMonthItem } from '../../../../../model/billing-center';
import { BillOrderMode } from '../../../../../model/billing-center/balance';
import styles from './index.module.scss';

export const getBillColumns = (userInfo: IAPIUserInfo | null) => {
  return [
    {
      key: 'consume_id',
      name: getFormatMessage('bill_id'),
    },
    {
      key: 'service_id',
      name: getFormatMessage('order_produce'),
      tableExtension: {
        renderRow() {
          return 'GVoice';
        },
      },
    },
    {
      key: 'tax_rate',
      name: getFormatMessage('apply_tax_rate'),
    },
    {
      key: 'consume_type',
      name: getFormatMessage('order_fee_mode'),
      tableExtension: {
        renderRow(key, value, row) {
          if (row.consume_type === BillOrderMode.Postpaid) {
            return getFormatMessage('transaction_type_post_paid');
          }
          if (row.consume_type === BillOrderMode.Prepayment) {
            return getFormatMessage('transaction_type_pre_paid');
          }
          return '';
        },
      },
    },
    {
      key: 'create_time',
      name: getFormatMessage('bill_pay_time'),
      tableExtension: {
        renderRow(key, value) {
          return getLocalTime(value, userInfo?.UserSettings?.Timezone);
        },
      },
    },
    {
      key: 'amount',
      name: getFormatMessage('bill_pay_money'),
    },
    {
      key: 'amount',
      name: getFormatMessage('can_open_amount'),
    },
  ] as IConfigField<IBillAsBillOrMonthItem>[];
};

export const MONTH_COLUMNS: IConfigField<IBillAsBillOrMonthItem>[] = [
  {
    key: 'consume_id',
    name: getFormatMessage('bill'),
    tableExtension: {
      renderRow(key, value, record) {
        return `${record.year}${getFormatMessage('bill_year')}${
          record.month
        }${getFormatMessage('bill_month')}`;
      },
    },
  },
  {
    key: 'amount',
    name: getFormatMessage('bill_pay_money'),
  },
  {
    key: 'amount',
    name: getFormatMessage('can_open_amount'),
  },
  {
    key: 'alreadyOpen',
    name: getFormatMessage('already_open_amount'),
  },
  {
    key: 'amount',
    name: getFormatMessage('less_open_amount'),
  },
];

export const getSubTable = (list: IAPICanOpenInvoiceBillItem[] = []) => {
  return (
    <div className={styles.subTable}>
      <div>{getFormatMessage('bill_product_name')}</div>
      <div>{getFormatMessage('apply_tax_rate')}</div>
      <div>{getFormatMessage('order_fee_mode')}</div>
      <div>{getFormatMessage('already_open_amount')}</div>
      <div>{getFormatMessage('less_open_amount')}</div>
      {list.map((item) => {
        return (
          <>
            <div>GVoice</div>
            <div>{item.tax_rate}</div>
            <div>{getFormatMessage('transaction_type_post_paid')}</div>
            <div>{item.amount}</div>
            <div>{item.amount}</div>
          </>
        );
      })}
    </div>
  );
};

export const formatBillsAsMonth = (
  list: IAPICanOpenInvoiceBillItem[]
): IBillAsBillOrMonthItem[] => {
  const monthCollect = list.reduce<
    Record<string, IAPICanOpenInvoiceBillItem[]>
  >((acc, bill) => {
    const month = moment(bill.create_time).format('YYYY-MM');
    const monthList = acc[month] || [];
    monthList.push(bill);
    acc[month] = monthList;
    return acc;
  }, {});

  return Object.keys(monthCollect)
    .map((date) => {
      const bills = monthCollect[date];
      const canOpenBills = bills.filter(
        (item) => !item['invoice_order.amount']
      );
      const alreadyOpenBills = bills.filter(
        (item) => item['invoice_order.amount']
      );
      return {
        key: date,
        year: date.split('-')[0],
        month: date.split('-')[1],
        bills: bills.filter((item) => !item['invoice_order.amount']),

        alreadyOpen: String(
          alreadyOpenBills.reduce((acc, bill) => {
            return acc + Number(bill.amount);
          }, 0)
        ),
        amount: String(
          canOpenBills.reduce((acc, bill) => {
            return acc + Number(bill.amount);
          }, 0)
        ),
      };
    })
    .filter((record) => record.bills.length);
};

export const getCanOpenMoney = (list: IAPICanOpenInvoiceBillItem[] = []) => {
  return list
    .filter((item) => !item['invoice_order.amount'])
    .reduce((acc, item) => {
      return acc + Number(item.amount);
    }, 0);
};
